import { useMutation } from "@tanstack/react-query";
import { ApiError, ApiServiceError } from "libs/api";
import { MutationOptions } from "libs/reactQuery";

import { requestBannersReorder } from "./bannersReorder.request";

const useBannersReorder = (
  options?: MutationOptions<void, ApiServiceError<ApiError>>
) => {
  return useMutation({
    mutationFn: requestBannersReorder,
    ...options
  });
};

export default useBannersReorder;
